// extracted by mini-css-extract-plugin
export default {"title":"_806582c8b5","inner_title":"ac4ce17bdf","charge_btn":"_850b49819f"};